(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[53449],{

/***/ 32031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SecureIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function SecureIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "32",
        viewBox: "0 0 26 32",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#3EDC84",
            fillRule: "nonzero",
            d: "M24.907 5.862a27.823 27.823 0 01-10.026-4.8L13.867.291a1.437 1.437 0 00-1.734 0l-1.01.766a27.827 27.827 0 01-10.027 4.8A1.454 1.454 0 000 7.273v6.72a17.226 17.226 0 006.796 13.684l5.337 4.032c.514.388 1.22.388 1.734 0l5.344-4.032A17.227 17.227 0 0026 13.993v-6.72c0-.667-.45-1.25-1.093-1.411zm-6.33 8.685l-6.018 6.013a1.505 1.505 0 01-2.127 0l-3.01-3.006a1.502 1.502 0 01.019-2.107 1.506 1.506 0 012.109-.019l1.945 1.944 4.955-4.95a1.506 1.506 0 012.11.018c.58.58.588 1.518.018 2.107z"
        })
    });
}


/***/ }),

/***/ 53449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_svg_secureIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32031);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_lib_vpnpricecomparison_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79188);
/* harmony import */ var _styles_variables_vpnpricecomparisonVariables_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75735);
/* harmony import */ var _styles_variables_vpnpricecomparisonVariables_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_vpnpricecomparisonVariables_module_scss__WEBPACK_IMPORTED_MODULE_4__);





function Footer() {
    const copyright = `© ${new Date().getFullYear()} VPNPriceComparison. All Rights Reserved`;
    const bestVpn = `Best VPNs Services in ${new Date().getFullYear()}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        className: "py-5 pb-10 lg:pb-14 text-center px-4 max-w-7xl mx-auto mt-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                borderColor: (_styles_variables_vpnpricecomparisonVariables_module_scss__WEBPACK_IMPORTED_MODULE_4___default().paleGrey)
            },
            className: "inner lg:flex lg:justify-between pt-6 border-t-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "lg:w-5/12",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-xl font-bold lg:hidden",
                            children: bestVpn
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm font-light mt-2 lg:text-left w-11/12 mx-auto text-vpn-comparison-slightly-black lg:hidden",
                            children: "We are committed to providing honest reviews and advice about VPN services to help protect your online privacy and security.Since 2016, we’ve reviewed 69 VPN services and published 4,515 real user reviews."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm font-medium mt-5 lg:text-left",
                            children: "Granted Security with SSL Certificate."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row justify-center items-center mt-2 lg:justify-start font-medium",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_secureIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "ml-3 text-sm font-light",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            className: "font-medium",
                                            children: "SECURE"
                                        }),
                                        " SSL ENCRYPTION"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-7 lg:mb-0 lg:flex lg:flex-col lg:justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                className: "flex justify-center",
                                children: src_lib_vpnpricecomparison_menu__WEBPACK_IMPORTED_MODULE_3__/* .footerMenu.map */ .T.map((menuItem, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: "px-3 text-vpn-comparison-slightly-black font-light",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "hover:text-vpn-comparison-melon",
                                            href: menuItem.href,
                                            children: menuItem.label
                                        })
                                    }, index))
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "copyright text-xs font-light mt-3 lg:mt-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: copyright
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 79188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ footerMenu; }
/* harmony export */ });
const footerMenu = [
    {
        label: "Home",
        href: "/"
    },
    {
        label: "Contact Us",
        href: "/contact-us"
    },
    {
        label: "Privacy Policy",
        href: "/privacy-policy"
    }, 
];


/***/ }),

/***/ 75735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem"};

/***/ })

}]);